import { RouterConfig } from 'src/routers/urlConfig';

export interface ILoginParam {
  username: string;
  password?: string;
  remember?: boolean;
  system?: string;
}

export interface ILoginResult {
  access_token?: string;
  refresh_token?: string;
  expires_in?: number;
  extra_data?: IUserRule;
  // key?: string;
}

export interface IUserRule {
  functions: RouterConfig.IMenuData[];
}

export interface IResetPassword {
  username: string;
  code: string;
  mobile?: string;
  email?: string;
  password: string;
}

export interface IVerificationCode {
  mobile?: string;
  email?: string;
}

export const ResetByMobile = 'ResetByMobile';
export type ResetByMobile = typeof ResetByMobile;
export const ResetByEmail = 'ResetByEmail';
export type ResetByEmail = typeof ResetByEmail;
export type ResetPwdType = ResetByMobile | ResetByEmail;



// WEBPACK FOOTER //
// ./src/entity/LoginParam.ts